const { regexes, accountType } = require('@transfeeradev/api-enums');

const defaultSchema = {
  bankCode: {
    maxLength: 3,
    required: false,
    pattern: regexes.bankAccount.BANK_CODE
  },
  bankISPB: {
    minLength: 8,
    maxLength: 8,
    required: false,
    pattern: regexes.bankAccount.BANK_ISPB
  },
  agency: {
    maxLength: 4,
    required: true,
    pattern: regexes.bankAccount.AGENCY,
    moreOpenPattern: regexes.bankAccount.ACCEPT_AGENCY_WITH_ONLY_ZEROS,
    digit: {
      exactLength: 1,
      required: false,
      pattern: regexes.bankAccount.DIGIT
    }
  },
  account: {
    maxLength: 12,
    required: true,
    pattern: regexes.bankAccount.ACCOUNT,
    digit: {
      exactLength: 1,
      required: true,
      pattern: regexes.bankAccount.DIGIT
    }
  },
  accountType: {
    required: true,
    allowedTypes: [accountType.CONTA_CORRENTE, accountType.CONTA_POUPANCA, accountType.CONTA_PAGAMENTO]
  }
};

module.exports = defaultSchema;
